'use es6';

import http from 'hub-http/clients/apiClient';
import { Map as ImmutableMap } from 'immutable';
import get from 'transmute/get';
import { formatSlackUsers, formatSlackUsersMap } from 'reference-resolvers/formatters/formatSlackUsers';
import { formatSlackChannels, formatSlackChannelsMap } from 'reference-resolvers/formatters/formatSlackChannels';
export const createGetSlackChannelsByIds = ({
  httpClient
}) => ids => httpClient.post('slack-integration/v1/slack/channels/batch/by-slack-channel-id', {
  data: ids
}).then(get('results')).then(formatSlackChannelsMap);
export const getSlackChannelsByIds = createGetSlackChannelsByIds({
  httpClient: http
});
export const createGetSlackUsersByIds = ({
  httpClient
}) => ids => httpClient.post('slack-integration/v1/slack/users/batch/by-slack-user-id', {
  data: ids
}).then(get('results')).then(formatSlackUsersMap);
export const getSlackUsersByIds = createGetSlackUsersByIds({
  httpClient: http
});
export const createGetSlackUsersSearchPage = ({
  httpClient
}) => props => {
  const {
    count,
    nextCursor,
    query
  } = props.toJS();
  const querystring = {
    name: query,
    limit: count,
    nextCursor
  };
  return httpClient.get('slack-integration/v1/slack/users/page', {
    query: querystring
  }).then(response => {
    const {
      users,
      nextCursor: responseNextCursor
    } = response;
    const results = formatSlackUsers(users);
    return ImmutableMap({
      count: results.size,
      hasMore: !!responseNextCursor,
      nextCursor: responseNextCursor,
      results,
      // Because this is cursor paginated, we don't need to keep track of offset.
      // However, ReferenceInputEnumSearch expects a value here.
      offset: 0
    });
  });
};
export const getSlackUsersSearchPage = createGetSlackUsersSearchPage({
  httpClient: http
});
export const createGetSlackChannelsSearchPage = ({
  httpClient
}) => props => {
  const {
    count,
    nextCursor,
    query
  } = props.toJS();
  const querystring = {
    channelName: query,
    limit: count,
    nextCursor
  };
  return httpClient.get('slack-integration/v1/slack/channels/page', {
    query: querystring
  }).then(response => {
    const {
      channels,
      nextCursor: responseNextCursor
    } = response;
    const results = formatSlackChannels(channels);
    return ImmutableMap({
      count: results.size,
      hasMore: !!responseNextCursor,
      nextCursor: responseNextCursor,
      results,
      // Because this is cursor paginated, we don't need to keep track of offset.
      // However, ReferenceInputEnumSearch expects a value here.
      offset: 0
    });
  });
};
export const getSlackChannelsSearchPage = createGetSlackChannelsSearchPage({
  httpClient: http
});